import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next('/login');
      },
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    meta: { title: "Page Not Found" },
    component: () => import("../views/error/404.vue"),
  },

  {
    path: "/pengaturan-akun",
    name: "pengaturan-akun",
    meta: { title: "Pengaturan Akun", authRequired: true },
    component: () => import("../views/account/profile"),
  },
  {
    path: "/master-data/user-management",
    name: "user-management",
    meta: { title: "User", authRequired: true },
    component: () => import("../views/masterdata/user"),
  },
  {
    path: "/master-data/anggota",
    name: "anggota",
    meta: { title: "User", authRequired: true },
    component: () => import("../views/masterdata/anggota"),
  },
  {
    path: "/master-data/satker",
    name: "satker",
    meta: { title: "SatKer", authRequired: true },
    component: () => import("../views/masterdata/satker"),
  },
  {
    path: "/master-data/kategori-barang",
    name: "kategori-barang",
    meta: { title: "Kategori Barang", authRequired: true },
    component: () => import("../views/masterdata/ktgrBrg"),
  },
  {
    path: "/master-data/sub-kategori-barang",
    name: "subkategori-barang",
    meta: { title: "Sub Kategori Barang", authRequired: true },
    component: () => import("../views/masterdata/subKatBrg"),
  },
  {
    path: "/master-data/satuan-barang",
    name: "satuan-barang",
    meta: { title: "Satuan Barang", authRequired: true },
    component: () => import("../views/masterdata/satuanBrg"),
  },
  {
    path: "/master-data/status-barang-bukti",
    name: "status-barang-bukti",
    meta: { title: "Status Barang Bukti", authRequired: true },
    component: () => import("../views/masterdata/statusBarbuk"),
  },
  {
    path: "/master-data/uraian-status-barang-bukti",
    name: "uraian-status-barang-bukti",
    meta: { title: "Status Barang Bukti", authRequired: true },
    component: () => import("../views/masterdata/statusUraian"),
  },
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/dashboard.vue"),
  },
  {
    path: "/statistik",
    name: "statistik",
    meta: {
      title: "Statistik",
      authRequired: true,
    },
    component: () => import("../views/dashboard/statistik.vue"),
  },
  {
    path: "/tahanan",
    name: "tahanan",
    meta: {
      title: "Statistik",
      authRequired: true,
    },
    component: () => import("../views/dashboard/tahanan.vue"),
  },
  {
    path: "/kasus",
    name: "kasus",
    meta: { title: "Kasus", authRequired: true },
    component: () => import("../views/kasus/kasus.vue"),
  },
  {
    path: "/kasus/form",
    name: "form-kasus",
    meta: { title: "Kasus", authRequired: true },
    component: () => import("../views/kasus/form-kasus.vue"),
  },
  {
    path: "/data-tahanan",
    name: "data-tahanan",
    meta: { title: "Data Tahanan", authRequired: true },
    component: () => import("../views/data-tahanan/data-tahanan.vue"),
  },
  {
    path: "/data-tahanan/form",
    name: "form-data-tahanan",
    meta: { title: "Data Tahanan", authRequired: true },
    component: () => import("../views/data-tahanan/form-data-tahanan.vue"),
  },
  {
    path: "/pendataan-barang-bukti",
    name: "pendataan-barang-bukti",
    meta: { title: "Pendataan Barang Bukti", authRequired: true },
    component: () =>
      import("../views/pendataan-barang-bukti/pendataan-barang-bukti.vue"),
  },
  {
    path: "/pendataan-barang-bukti/form",
    name: "form-pendataan-barang-bukti",
    meta: { title: "Pendataan Barang Bukti", authRequired: true },
    component: () =>
      import("../views/pendataan-barang-bukti/form-pendataan-barang-bukti.vue"),
  },
  {
    path: "/peminjaman-barang-bukti",
    name: "peminjaman-barang-bukti",
    meta: { title: "Peminjaman Barang Bukti", authRequired: true },
    component: () =>
      import("../views/peminjaman-barang-bukti/peminjaman-barang-bukti.vue"),
  },
  {
    path: "/peminjaman-barang-bukti/form",
    name: "form-peminjaman-barang-bukti",
    meta: { title: "Peminjaman Barang Bukti", authRequired: true },
    component: () =>
      import(
        "../views/peminjaman-barang-bukti/form-peminjaman-barang-bukti.vue"
      ),
  },
];
